import { Skeleton } from '@mui/material';
import classNames from 'classnames/bind';

import styles from './Form.module.css';
import { useMemo } from 'react';
const classCtx = classNames.bind(styles);

interface FieldSkeletonProps {
	labelText?: string;
	containerClassName?: string;
	skeletonClassName?: string;
	checkbox?: boolean;
	width?: string | number;
	height?: string | number;
}

export default function FieldSkeleton(props: FieldSkeletonProps) {
	const containerStyles = classCtx({
		['skeleton-root']: true,
		['skeleton-chk-container']: props.checkbox,
		[props.containerClassName ?? '']: Boolean(props.containerClassName)
	});

	const skeletonStyles = classCtx({
		skeleton: true,
		[props.skeletonClassName ?? '']: Boolean(props.skeletonClassName)
	});

	const skeletonHeight = useMemo(() => {
		if (props.checkbox) return 16;
		if (props.height) return props.height;
		return 40; // Default MUI Input Height
	}, [props]);

	const skeletonWidth = useMemo(() => {
		if (props.checkbox) return 16;
		if (props.width) return props.width;
		return undefined;
	}, [props]);

	return (
		<div
			className={containerStyles}
			style={{
				width: props.width
			}}
		>
			{props.labelText && <span className={styles.label}>{props.labelText}</span>}

			<Skeleton
				variant='rounded'
				className={skeletonStyles}
				height={skeletonHeight}
				width={skeletonWidth}
			/>
		</div>
	);
}
